<template>
  <div class="animated fadeIn">
    <b-card size="sm">
      <div slot="header">
        <i class="icon-calendar"></i> Template Jadwal Kunjungan
      </div>
      <b-row>
        <b-col lg="4" v-bind:key="index" v-for="(i, index) in days" sm="4" md="4">
          <global-table
            :table-data="items[i.day]"
            :loading="loading"
            :per-page="10"
            :bordered="true"
            :table-detail="tableDetail"
            :hover="true"
            :striped="false"
            :fields="fields"
            :row-edit="addForm"
            :redirect-detail="false"
            :show-add-button="true"
            :caption="caption+' '+i.name"
            :id-modals="i.day"
            addButton="Tambah"
            @editForm="editForm"
            @resetForm="resetForm"
            @showDetail="showDetail"
          ></global-table>
          <b-modal
            :id="i.day"
            header-border-variant="no-border text-center"
            footer-border-variant="no-border"
            footer-bg-variant="light"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            size="lg"
          >
            <div slot="modal-header" class="text-center">
              <h3 class="text-center">Masukkan plan jadwal untuk {{i.name}}</h3>
            </div>

            <b-form id="employeeForm" validated novalidate>
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="mitra_kerja" label="Mitra Kerja">
                    <b-form-select
                      id="mitra_kerja"
                      :options="listMitraKerja"
                      v-model="$v.addForm.mitra_kerja.$model"
                      :state="!$v.addForm.mitra_kerja.$invalid"
                      required
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback>Mitra Kerja harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group label-for="dc_code" label="Kode DC">
                    <b-form-select
                      id="dc_code"
                      :options="listMitraDc"
                      v-model="$v.addForm.dc_code.$model"
                      :state="!$v.addForm.dc_code.$invalid"
                      required
                      @change="filterStore($event)"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback>Mitra DC harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group label-for="store_id" label="Nama Toko">
                    <b-form-select
                      id="store_id"
                      :options="listStore"
                      v-model="$v.addForm.store_id.$model"
                      :state="!$v.addForm.store_id.$invalid"
                      required
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback>Toko harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>

            <div slot="modal-footer" class="float-right">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd(i.day)">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="submitAdd($event, i.day)"
                :disabled="$v.addForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </b-modal>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-modal
            ref="myModalRef"
            id="openDetail"
            header-border-variant="no-border text-center"
            footer-border-variant="no-border"
            footer-bg-variant="light"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            size="lg"
          >
            <div slot="modal-header" class="text-center">
              <h3 class="text-center"></h3>
            </div>

            <b-col>
              <b-card>
                <p>
                  <strong>{{details.mitra_kerja_name}}</strong>
                </p>
                <b-form>
                  <b-form-group label-for="mitra_kerja" label="Mitra">
                    <b-form-select
                      class="col-lg-3"
                      id="mitra_kerja"
                      :options="listMitraKerja"
                      v-model="$v.updateForm.mitra_kerja.$model"
                      :state="!$v.updateForm.mitra_kerja.$invalid"
                      required
                      @change="filterStore($event)"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback>Mitra Kerja harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>
                </b-form>
                <table
                  class="responsive table table-sm"
                  v-bind:key="index"
                  v-for="(i, index) in details.store"
                >
                  <thead>
                    <tr>
                      <th colspan="3" style="border-top:0px solid #c8ced3;">{{index}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-bind:key="indx" v-for="(v, indx) in i">
                      <td class="w10" style="border-top:0px solid #c8ced3;">{{(indx+1)}}.</td>
                      <td style="border-top:0px solid #c8ced3;">{{v.name}}</td>
                      <td style="border-top:0px solid #c8ced3;" class="w10">
                        <b-button
                          type="button"
                          size="sm"
                          variant="danger"
                          title="Remove this data"
                          @click="removeRow(details.id, details.day_of_week)"
                        >
                          <i class="cui-circle-x icons"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-card>
            </b-col>

            <div slot="modal-footer" class="float-right">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd('openDetail')">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="updateSchedule"
                :disabled="$v.updateForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </b-modal>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>


<script>
import { Callout } from "@coreui/vue";
import globalTableOnly from "../../templates/TableOnly.vue";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required } from "vuelidate/lib/validators";

export default {
  name: "scheduleMitra",
  components: { Callout, globalTableOnly, globalTable },
  props: {
    flag: {
      type: Boolean,
      default: false
    },
    tableDetail: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: true
    },
    caption: {
      type: String,
      default: "<i class='fa fa-align-justify'></i>"
    },
    idModals: {
      type: String,
      default: "addModals"
    }
  },
  validations: {
    addForm: {
      mitra_kerja: { required },
      store_id: { required },
      day_of_week: {},
      dc_code: { required },
      flag: {},
      date_inserted: {}
    },
    updateForm: {
      mitra_kerja: { required }
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  data() {
    return {
      sortBy: "username",
      sortDesc: false,
      loading: false,
      listMitraKerja: [],
      listMitraDc: [],
      listStore: [],
      listTempStore: [],
      days: [
        {
          day: "1",
          name: "Senin"
        },
        {
          day: "2",
          name: "Selasa"
        },
        {
          day: "3",
          name: "Rabu"
        },
        {
          day: "4",
          name: "Kamis"
        },
        {
          day: "5",
          name: "Jumat"
        },
        {
          day: "6",
          name: "Sabtu"
        },
        {
          day: "7",
          name: "Minggu"
        }
      ],
      currentPage: 1,
      addForm: interfaces.schedule_plan,
      updateForm: { mitra_kerja: null },
      fields: [
        { key: "mitra_kerja_name", label: "Nama", sortable: true },
        { key: "total_store", label: "Jumlah toko", sortable: true },
        { key: "show_detail", label: "Detail" }
      ],
      items: [],
      details: []
    };
  },
  methods: {
    init: function() {
      this.axios
        .get("schedule/all/")
        .then(response => {
          this.items = response.data.data;
        })
        .catch(error => {
          this.showErrorNotification({
            title: "Jadwal",
            message: error.response.data.message
          });
        });

      this.axios
        .get("dropdown/all/")
        .then(response => {
          this.listMitraKerja = response.data.mitraKerja;
          this.listMitraDc = response.data.mitraDc;
          this.listTempStore = response.data.indomaret;
        })
        .catch(error => {
          this.showErrorNotification({
            title: "Add Employee",
            message: error.response.data.message
          });
        });
    },
    cancelAdd: function(idM) {
      this.$root.$emit("bv::hide::modal", idM);
    },
    editForm: function(a) {
      this.resetForm();
      //this.addForm = a;
    },
    removeRow: function(id, day_of_week) {
      if (confirm("Apakah anda ingin menghapus jadwal ini ?")) {
        let data = { id: id };
        this.axios
          .post("schedule/remove_schedule_plan/", data)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah Schedule Plan",
                message: response.data.message
              });
            } else {
              this.showErrorNotification({
                title: "Tambah Schedule Plan",
                message: response.data.message
              });
            }
            this.handleSubmit(day_of_week);
            this.cancelAdd("openDetail");
          })
          .catch(error => {
            // if (error.response.status === 401) {
            //   localStorage.clear();
            //   this.$router.push({ path: "/login" });
            //   this.showErrorNotification({
            //     title: "Token Expired",
            //     message: "Your session has been expired"
            //   });
            // } else {
            //   this.showErrorNotification({
            //     title: "Add Employee",
            //     message: error.response.data.message
            //   });
            // }
          });
      }
    },
    showDetail: function(a) {
      this.details = a.item;
      this.updateForm.mitra_kerja = this.details.mitra_kerja;
      console.log(this.details);
    },
    add: function(id) {
      console.log(id);
    },
    submitAdd: function(evt, days) {
      evt.preventDefault();

      if (confirm("Apakah anda ingin menambahkan jadwal ?")) {
        this.addForm.day_of_week = days;
        this.axios
          .post("schedule/add_schedule_plan/", this.addForm)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah Schedule Plan",
                message: response.data.message
              });
            } else {
              this.showErrorNotification({
                title: "Tambah Schedule Plan",
                message: response.data.message
              });
            }
            this.handleSubmit(days);
          })
          .catch(error => {
            if (error.response.status === 401) {
              localStorage.clear();
              this.$router.push({ path: "/login" });
              this.showErrorNotification({
                title: "Token Expired",
                message: "Your session has been expired"
              });
            } else {
              this.showErrorNotification({
                title: "Add Employee",
                message: error.response.data.message
              });
            }
          });
      }
    },
    updateSchedule: function() {
      if (confirm("Apakah anda yakin ingin mengubah mitra?")) {
        this.updateForm.day_of_week = this.details.day_of_week;
        this.updateForm.mitra_kerja_past = this.details.mitra_kerja;
        this.axios
          .put("schedule/update_schedule_plan/", this.updateForm)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Update Schedule Plan",
                message: response.data.message
              });
            } else {
              this.showErrorNotification({
                title: "Update Schedule Plan",
                message: response.data.message
              });
            }
            this.handleSubmit(this.details.day_of_week);
            this.cancelAdd("openDetail");
          })
          .catch(error => {
            if (error.response.status === 401) {
              localStorage.clear();
              this.$router.push({ path: "/login" });
              this.showErrorNotification({
                title: "Token Expired",
                message: "Your session has been expired"
              });
            } else {
              this.showErrorNotification({
                title: "Add Employee",
                message: error.response.data.message
              });
            }
          });
      }
    },
    handleSubmit: function(days) {
      this.resetForm();
      this.$root.$emit("bv::hide::modal", days);
      this.init();
    },
    resetForm: function() {
      for (var a in interfaces.schedule_plan) {
        interfaces.schedule_plan[a] = null;
      }
      this.addForm = interfaces.schedule_plan;
    },
    filterStore: function(dc_code) {
      this.listStore = this.listTempStore.filter(x => x.dc_code === dc_code);
    }
  },
  mounted() {
    this.init();
  }
};
</script>
